

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { BackendFormSchema } from '../models/dynamic-form.models';
import { ValidationRules } from '../models/validation-rule.model';
import { environment } from '../../../environments/environment';


export interface ListColumnConfigDto {
  field: string;
  label: string;
  isVisible: boolean;
  isSortable: boolean;
  width: number;
  seq: number;
  filterType: 'text' | 'number' | 'date' | 'select';
}
export interface PagedResult<T> {
  items: T[];
  totalCount: number;
}
@Injectable({ providedIn: 'root' })
export class SchemaApiService {

  private base = environment.apiUrl;   // your backend host
  private baseUrl = `${environment.apiUrl}/api/validation-rules`;   // your backend host

  constructor(private http: HttpClient) { }

  // ===============================
  //  SAVE (POST)
  // ===============================
  saveForm(entity: string, payload: any) {
    return this.http.post(`${this.base}/api/sys/form/${entity}/save`, payload);
  }

  // ===============================
  //  GET RECORD BY ID
  // ===============================
  // getRecord(entity: string, id: string): Observable<any> {
  //   return this.http.get(`${this.base}/api/sys/form/${entity}/${id}`);
  // }

  getRecord(entity: string, id: string, moduleCode: string): Observable<any> {
    // Adds ?moduleCode=INVENTORY to the URL
    return this.http.get(`${this.base}/api/sys/form/${entity}/${id}?moduleCode=${moduleCode}`);
  }
  // ===============================
  //  UPDATE RECORD
  // ===============================
  updateForm(entity: string, id: string, dto: any): Observable<any> {
    return this.http.put(`${this.base}/api/sys/form/${entity}/${id}`, dto);
  }

  // ===============================
  //  DELETE RECORD
  // ===============================
  deleteForm(entity: string, id: string): Observable<any> {
    return this.http.delete(`${this.base}/api/sys/form/${entity}/${id}`);
  }

  // ===============================
  //  GET SCHEMA
  // ===============================
  getSchema(entity: string): Observable<BackendFormSchema> {
    return this.http.get<BackendFormSchema>(`${this.base}/api/sys/admin/schema/${entity}`);
  }

  // ===============================
  //  LOOKUP AUTOCOMPLETE
  // ===============================
  // Inside SchemaApiService
  // lookup(api: string, q: string) {
  //   const baseUrl = this.base.endsWith('/') ? this.base : `${this.base}/`;
  //   // If api starts with slash, remove it to prevent double slash
  //   const cleanApi = api.startsWith('/') ? api.substring(1) : api;
  //   const url = api.startsWith('http') ? api : `${baseUrl}${cleanApi}`;

  //   const params = new HttpParams().set('q', q);
  //   return this.http.get<any[]>(url, { params });
  // }
  lookup(api: string, q: string, filters?: Record<string, any>) {

    const baseUrl = this.base.endsWith('/') ? this.base : `${this.base}/`;
    const cleanApi = api.startsWith('/') ? api.substring(1) : api;
    const url = api.startsWith('http') ? api : `${baseUrl}${cleanApi}`;

    let params = new HttpParams().set('q', q);

    if (filters) {
      Object.keys(filters).forEach(key => {
        params = params.set(key, filters[key]);
      });
    }

    return this.http.get<any[]>(url, { params });
  }
  // user.service.ts
  getOrgSuggestions(query: string) {
    // This hits the working endpoint: https://localhost:7056/api/lookups/organisation?q=...
    // Ensure 'api/lookups/organisation' matches the [Route("api/lookups")] and {lookupCode} in your controller.
    return this.lookup('api/lookups/organisation', query);
  }
  getById(api: string, id: any) {
    const baseUrl = this.base.endsWith('/') ? this.base : `${this.base}/`;
    const cleanApi = api.startsWith('/') ? api.substring(1) : api;
    const url = api.startsWith('http') ? api : `${baseUrl}${cleanApi}/${id}`;
    return this.http.get<any>(url);
  }

  // ✅ Column config
  getConfig(entity: string) {
    return this.http.get<ListColumnConfigDto[]>(
      `${this.base}/api/sys/listconfig/${entity}`
    );
  }

  // ✅ Entity list data
  getList(body: { entity: string; module: string;  page: number; pageSize: number; search: any; sortField: any; sortDir: any; filters: any }) {
    return this.http.post<any>(
      `${this.base}/api/sys/entitylist`,
      body
    );
  }

  // getList(body: { entity: string; page: number; pageSize: number; search: any; sortField: any; sortDir: any; filters: any }) {
  //   return this.http.post<any>(
  //     `${this.base}/api/sys/entitylist`,
  //     body
  //   );
  // }

  getRules(entity: string) {
    // Use backticks (`) and ${} to combine the base URL with the path
    return this.http.get<any[]>(`${this.base}/api/sys/form/validationrules/${entity}`);
  }

  // ===============================
  // DOCUMENT REFERENCE
  // ===============================
  generateReference(payload: {
    sourceEntity: string;
    targetEntity: string;
    referenceId: string;
  }) {
    return this.http.post<any>(
      `${this.base}/api/sys/documentreference/generate`,
      payload
    );
  }
  // validationRule

  // getAll() {
  //   return this.http.get<ValidationRules[]>(this.baseUrl);
  // }
  // Add this interface to your models if you haven't already


  // Update your service method
  getAll(pageIndex: number, pageSize: number, searchTerm: string = ''): Observable<PagedResult<ValidationRules>> {
    // Use HttpParams for a cleaner and safer URL structure
    const params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('searchTerm', searchTerm);

    // Use this.baseUrl instead of a hardcoded string
    return this.http.get<PagedResult<ValidationRules>>(this.baseUrl, { params });
  }
  create(rule: ValidationRules) {
    return this.http.post(this.baseUrl, rule);
  }

  update(rule: ValidationRules) {
    return this.http.put(this.baseUrl, rule);
  }

  delete(id: string) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }


  // add for a advance filter 

  // In your ApiService
  lookupRuntime(apiPath: string, searchText: string, extraFilters: any = {}) {
    const baseUrl = `${environment.apiUrl}`;

    // Smart extraction: gets "organisation" from "/api/lookups/organisation"
    const segments = apiPath.split('/');
    const lookupCode = segments[segments.length - 1];

    // Pointing to your new C# route: advfilter
    const url = `${baseUrl}/api/lookups/advfilter/${lookupCode}`;

    let params = new HttpParams()
      .set('q', searchText || '')
      .set('page', '1')
      .set('pageSize', '20');

    // Append any extra filters (like is_active) to the query string
    if (extraFilters) {
      Object.keys(extraFilters).forEach(key => {
        if (extraFilters[key] !== null && extraFilters[key] !== undefined) {
          params = params.set(key, extraFilters[key].toString());
        }
      });
    }

    return this.http.get<any[]>(url, { params });
  }
}
